module.exports = __webpack_public_path__ + "img/bg-600.60aaadc8.jpg";